import axios from "axios"
import smooth from "smoothscroll"
import { setLoading, setFinished, setInitial } from "./LoadingButton"
// import { checkRecaptchaScore } from "./Recaptcha"

export default () => {
  const forms = document.querySelectorAll(".js-form")
  const types = [...document.querySelectorAll(".js-product-detail-type")] // For prijsaanvraag page
  if (!forms.length) return

  ;[...forms].forEach(form => {
    // checkRecaptchaScore(form)
    form.addEventListener("submit", sendForm)
  })

  function sendForm(e) {
    e.preventDefault()
    const form = this
    const fd = new window.FormData(form)
    const button = form.querySelector(".c-button")

    if (types.length) {
      const checked = types.map(type => type.checked)
      if (!checked.includes(true)) {
        const notice = document.querySelector(".js-product-types-notion")
        notice.style.display = "block"
        smooth(document.getElementById("productkeuze"))
        return
      }
    }

    // Set button to loading
    setLoading(button)
    axios({
      method: "post",
      url: `/wordpress/wp-admin/admin-ajax.php?action=send_form`,
      data: fd,
      params: {
        data: form.action
      }
    })
      .then(r => {
        console.log(r)
        setFinished(button)
        sendGTAEvent(form)
        setTimeout(() => {
          setInitial(button)
          window.location = r.data.action
        }, 2000)
        clearForm(form)
        console.log(r)
      })
      .catch(e => {
        setInitial(button)
        clearForm(form)
      })
  }

  function sendGTAEvent(form) {

    let typeBrochure = 'Onbekend'
    let types = form.querySelectorAll("input[name='typebrochure']") //radio

    ;[...types].forEach(type => { 
      if (type.checked) { 
        typeBrochure = type.value
      }  
    })

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'formSent',
      form:
        form.querySelector("input[name='form_title']") !== undefined &&
        form.querySelector("input[name='form_title']") !== null
          ? form.querySelector("input[name='form_title']").value
          : 'Onbekend',
      product_referral:
        form.querySelector("input[name='product_referral']") !== undefined &&
        form.querySelector("input[name='product_referral']") !== null
          ? form.querySelector("input[name='product_referral']").value
          : 'Onbekend',
      type_brochure: typeBrochure
    })
  }

  const clearForm = form => {
    form.reset()
  }
}

// fill a form from console.log
window.fillForm = () => {
  const forms = document.querySelectorAll("form")
  if (!forms) return
  ;[...forms].forEach(form => {
    const inputs = form.querySelectorAll(".c-input__input")
    ;[...inputs].forEach(input => {
      const { type, required, name } = input
      if (required === true) {
        if (type === "text") {
          if (name === "Postcode") {
            input.value = "1234 AB"
          } else if (name === "url") {
            input.value = ""
          } else if (name === "Telefoonnummer") {
            input.value = "06-12345678"
          } else {
            input.value = `BRIGHT TEST ${Math.random()
              .toString(36)
              .substring(7)}`
          }
        } else if (type === "email") {
          input.value = "TEST@TEST.COM"
        } else if (type === "tel") {
          input.value = "06-12345678"
        } else if (name === "message") {
          input.value = "Message"
        } else if (name === "Postcode") {
          input.value = "1234 AB"
        } else if (name === "url") {
          input.value = ""
        }
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/SendForm.js